/**
 * See https://github.com/react-ga/react-ga/blob/master/demo/app/withTracker.jsx
 */

import React, { Component, } from "react";
import ReactGA from "react-ga";
import { css, cx, } from "emotion";
import mediaQueries from "./styles/mediaQueries";

const marginTop = css({
  marginTop: "35px",
  [mediaQueries.phone]: {
    marginTop: ".5rem",
  },
});

export default function withTracker(WrappedComponent, options = {}) {
  const trackPage = page => {
    ReactGA.set({
      page,
      ...options,
    });
    ReactGA.pageview(page);
    // I'm not sure whether ReactGA.pageview will 'double-up' with the
    // GA pageview tracking that's alredy being done through GTM.
    // Send a unique event along for each `pageview` event, so we can
    // correlate them for /private-home.
    ReactGA.event({
      category: "Insurance Quotes",
      action: "Pageview Tracking",
      label: page,
    });
  };

  const HOC = class extends Component {
    componentDidMount() {
      const page = this.props.location.pathname;
      trackPage(page);
    }

    componentDidUpdate(prevProps) {
      const currentPage = this.props.location.pathname;
      const lastPage = prevProps.location.pathname;

      if (currentPage !== lastPage) {
        trackPage(currentPage);
      }
    }

    render() {
      return (
        <div className={cx("container mb-5", marginTop)}>
          <WrappedComponent {...this.props} />
        </div>
      );
    }
  };

  return HOC;
}



// WEBPACK FOOTER //
// ./src/withTracker.js